import React from "react";
import { Modal, Button } from "react-bootstrap";
import { formatDateToDDMMYYYY } from "../../../../Utility/constants";

const TeacherDetailsModal = ({ show, handleDetailsClose, teacherDetails }) => {
  if (!teacherDetails) return null;

  return (
    <Modal show={show} onHide={handleDetailsClose} dialogClassName="custom-modal-lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Teacher Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div>
          <table className="table table-bordered">
            <tbody>

              {/* Row 1 */}
              <tr>
                <th>Full Name</th>
                <td>{teacherDetails.fullName}</td>

                <th>Gender</th>
                <td>{teacherDetails.gender}</td>

                <th>Contact No.</th>
                <td>{teacherDetails.phone}</td>
              </tr>

              {/* Row 2 */}
              <tr>
                <th>Email</th>
                <td>{teacherDetails.email}</td>

                <th>Date of Birth</th>
                <td>{teacherDetails.dateOfBirth ? formatDateToDDMMYYYY(teacherDetails.dateOfBirth) : ""}</td>

                <th>Joining Date</th>
                <td>{teacherDetails.joiningDate ? formatDateToDDMMYYYY(teacherDetails.joiningDate) : ""}</td>
              </tr>

              {/* Row 3 */}
              <tr>
                <th>Address</th>
                <td>{teacherDetails.address}</td>

                <th>Role</th>
                <td>{teacherDetails.role}</td>

                <th>Teacher Type</th>
                <td>{teacherDetails.teacherType}</td>
              </tr>

              {/* Row 4 */}
              <tr>
                {/* <th>Salary</th>
                <td>{teacherDetails.salary}</td> */}

                <th>Aadhaar Number</th>
                <td>{teacherDetails.aadhaarCardNumber}</td>

                <th>Grant Type</th>
                <td>{teacherDetails.grantTypeName}</td>
              </tr>

              {/* Row 5 */}
              <tr>
                <th>Pay Scale Salary</th>
                <td>{teacherDetails.payScaleSalary}</td>

                <th>Educational Qualification</th>
                <td>{teacherDetails.educationalQualification}</td>

                <th>Chart Type</th>
                <td>{teacherDetails.chartType}</td>
              </tr>

              {/* Row 6 */}
              <tr>
                <th>Post Type</th>
                <td>{teacherDetails.postType}</td>

                <th>Retirement Date</th>
                <td>
                  {teacherDetails.retirementDate
                    ? formatDateToDDMMYYYY(teacherDetails.retirementDate)
                    : ""}
                </td>

                <th>Designation</th>
                <td>{teacherDetails.designation || ""}</td>
              </tr>

              {/* Row 7 */}
              <tr>
                <th>Pay Grade Sanctioned Date</th>
                <td>
                  {teacherDetails.payGradeSanctionedDate
                    ? formatDateToDDMMYYYY(teacherDetails.payGradeSanctionedDate)
                    : ""}
                </td>

                <th>Selection Category Approved Date</th>
                <td>
                  {teacherDetails.selectionCategoryApprovedDate
                    ? formatDateToDDMMYYYY(teacherDetails.selectionCategoryApprovedDate)
                    : ""}
                </td>

                <th>Caste Category</th>
                <td>{teacherDetails.teacherCategoryName}</td>
              </tr>

              {/* Row 8 */}
              <tr>
                <th>Vaiyaktik Manyata</th>
                <td>{teacherDetails.vaiyaktikManyata}</td>

                <th>VM Date</th>
                <td>
                  {teacherDetails.vaiyaktikManyataDate
                    ? formatDateToDDMMYYYY(teacherDetails.vaiyaktikManyataDate)
                    : ""}
                </td>

                <th>VM Outward No</th>
                <td>{teacherDetails.vaiyaktikManyataOutwardNumber}</td>
              </tr>

              {/* Row 9 – Photos */}
              <tr>
                <th>Teacher Photo</th>
                <td colSpan={2}>
                  {teacherDetails.teacherPhoto ? (
                    <img
                      src={teacherDetails.teacherPhoto}
                      alt="Teacher"
                      height="100"
                    />
                  ) : (
                    "No Photo"
                  )}
                </td>

                <th>Vaiyaktik Manyata Photo</th>
                <td colSpan={2}>
                  {teacherDetails.vaiyaktikManyataPhoto ? (
                    <img
                      src={teacherDetails.vaiyaktikManyataPhoto}
                      alt="Vaiyaktik Manyata"
                      height="100"
                    />
                  ) : (
                    "No Photo"
                  )}
                </td>
              </tr>

            </tbody>
          </table>

          {/* Subject Class Details */}
          {teacherDetails.role?.toLowerCase() === "teacher" && (
            <table className="table table-bordered table-striped mt-3">
              <thead>
                <tr>
                  <th>Class</th>
                  <th>Section</th>
                  <th>Stream</th>
                  <th>Subject</th>
                  <th>Is Class Teacher</th>
                </tr>
              </thead>
              <tbody>
                {teacherDetails.subjectClassDetails?.length ? (
                  teacherDetails.subjectClassDetails.map((item, index) => (
                    <tr key={index}>
                      <td>{item.className}</td>
                      <td>{item.sectionName}</td>
                      <td>{item.streamName}</td>
                      <td>{item.subjectName}</td>
                      <td>{item.isClassTeacher === 1 ? "Yes" : "No"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No subject class details available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleDetailsClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TeacherDetailsModal;
